import React from 'react'

const Home3 = () => {
  return <h1>home3</h1>
}

export default Home3
